<input [id]="id"
       class="radio"
       [name]="shortcut"
       type="radio"
       [checked]="selected ? 'checked' : ''"/>
<label class="text"
       [for]="id">
    <span class="circle"></span>
    <span class="container">
      <ng-content></ng-content>
    </span>
</label>